import getStore from '../store';
import { ResultFilterOption, getSearchableAsset } from 'owa-timestream-asset-search';

export function currentSearchPivotKey(): string {
    const store = getStore();
    return store.currentSearchPivotKey;
}

export function currentFilterKey(): string {
    const store = getStore();
    return store.currentFilterKey;
}

export function selectedResultFilter(): ResultFilterOption {
    const selectedKey = currentFilterKey();
    const searchPivotKey = currentSearchPivotKey();
    const searchableAsset = getSearchableAsset(searchPivotKey);
    const getFilterOptionsFunction = searchableAsset?.getResultFilterOptions;
    const filterOptions = getFilterOptionsFunction ? getFilterOptionsFunction() : [];
    return filterOptions.filter(filterOption => filterOption.id === selectedKey)[0];
}
